import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { DateRangeInput, type DateRangeInputProps } from '../date-range-input';

type FormDateRangeInputProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  DateRangeInputProps;

function FormDateRangeInput<TFieldValues extends FieldValues = FieldValues>(
  props: FormDateRangeInputProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController(props);

  return (
    <DateRangeInput
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText}
      required={!!(props.rules?.required ?? props.required)}
      ref={ref}
      onChange={(value) => {
        field.onChange(value);
        props.onChange?.(value);
      }}
    />
  );
}

export type { FormDateRangeInputProps };
export { FormDateRangeInput };
